import React from 'react';
import useTranslation from '../../../../../../Hooks/useTranslation';
import { joinClasses } from '../../../../../../Utils/className.util';
import {
	INSURANCE_COMPANY_BATCH_STATUS_BADGE_CLASS,
	INSURANCE_COMPANY_BATCH_STATUS_LABEL,
	InsuranceCompanyBatchDisplayStatus,
} from '../../../../Consts/InsuranceCompanyBatchStatus.const';
import styles from './ManagerInsuranceCompaniesBatchStatusBadge.module.scss';

interface Props {
	status: InsuranceCompanyBatchDisplayStatus;
}

const ManagerInsuranceCompaniesBatchStatusBadge = ({ status }: Props) => {
	const { t } = useTranslation();
	const colorClass =
		styles[
			INSURANCE_COMPANY_BATCH_STATUS_BADGE_CLASS[status] as keyof typeof styles
		];

	return (
		<span className={joinClasses([styles.wrapper, colorClass])}>
			{t(INSURANCE_COMPANY_BATCH_STATUS_LABEL[status])}
		</span>
	);
};

export default ManagerInsuranceCompaniesBatchStatusBadge;
